import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiLinux,
  SiVisualstudiocode,
  SiPostman,
  SiVercel,
  SiGithub,
} from "react-icons/si";
import ScrollReveal from "../ScrollReveal/ScrollReveal";

const tools = [
  { label: "Linux", icon: <SiLinux /> },
  { label: "VS Code", icon: <SiVisualstudiocode /> },
  { label: "Postman", icon: <SiPostman /> },
  { label: "Vercel", icon: <SiVercel /> },
  { label: "GitHub", icon: <SiGithub /> },
];

function Toolstack() {
  return (
    <Row className="stack-grid">
      {tools.map((item) => (
        <Col xs={6} md={4} xl={2} key={item.label}>
          <ScrollReveal className="tech-icons" delay={tools.indexOf(item) * 55} distance={16}>
            <span>{item.icon}</span>
            <small>{item.label}</small>
          </ScrollReveal>
        </Col>
      ))}
    </Row>
  );
}

export default Toolstack;
